/* @flow */

import React from 'react';
import { Menu } from 'semantic-ui-react';
import AddBlockButton from './AddBlockButton';

type Props = {
  templates: Array<EditorialBlockTemplate>,
  onAdd: (type: EditorialBlockType) => void,
  attached?: boolean,
  locked?: boolean,
};

const BlocksHeader = ({ templates, attached, onAdd, locked }: Props) => {
  return (
    <Menu size="small" attached={attached || 'top'}>
      <Menu.Item header className="borderless">Contenus éditoriaux</Menu.Item>
      {!locked &&
        <Menu.Menu position="right">
          <Menu.Item>
            <AddBlockButton templates={templates} onAdd={onAdd} />
          </Menu.Item>
        </Menu.Menu>}
    </Menu>
  );
};

export default BlocksHeader;



// WEBPACK FOOTER //
// ./src/modules/edito/components/BlocksHeader.js